export class BikeGeolocation {
    deviceIMEI: string;
    timestamp: Date;
    latitude: string;
    longitude: string;
}
